module.exports = __webpack_public_path__ + "static/road-e3374842a512ddcf7adad5f7bab2528a.jpg";